// extracted by css-extract-rspack-plugin
export default {"root":"nm05iaGFNcw3w6Kj","gravatar":"Xu1xazC5dvgYdwUI"};